import { Partida } from '../services/partidaService';
import { PartidaLite } from '../services/faseGrupoPartidasService';
import { Partida as PartidaGraphQL } from '../types/graphql';

/**
 * Tipo unificado para partidas que podem ter WO/desistência
 */
type PartidaComWO = 
  | Partida 
  | PartidaLite 
  | PartidaGraphQL
  | { 
      equipeAWO?: boolean | null;
      equipeBWO?: boolean | null;
      equipeADesistencia?: boolean | null;
      equipeBDesistencia?: boolean | null;
      placar?: {
        resultadoFinalA?: number | null;
        resultadoFinalB?: number | null;
      } | null;
    };

/**
 * Formata o resultado de uma partida considerando WO, desistência e placar.
 * 
 * @param partida - Objeto da partida com campos de WO/desistência e placar
 * @returns String formatada com o resultado da partida
 */
export function formatMatchResult(partida: PartidaComWO): string {
  // Verificar WO primeiro (tem precedência sobre desistência)
  if (partida.equipeAWO === true) {
    return 'WO - Equipe B venceu';
  }
  if (partida.equipeBWO === true) {
    return 'WO - Equipe A venceu';
  }
  
  // Verificar desistência
  if (partida.equipeADesistencia === true) {
    return 'Desistência - Equipe B venceu';
  }
  if (partida.equipeBDesistencia === true) {
    return 'Desistência - Equipe A venceu';
  }
  
  // Se não houver WO nem desistência, mostrar placar
  const placar = partida.placar;
  if (
    !placar ||
    placar.resultadoFinalA === null ||
    placar.resultadoFinalA === undefined ||
    placar.resultadoFinalB === null ||
    placar.resultadoFinalB === undefined
  ) {
    return 'Pendente';
  }
  
  return `${placar.resultadoFinalA} x ${placar.resultadoFinalB}`;
}

/**
 * Verifica se uma partida tem WO
 */
export function hasWO(partida: PartidaComWO): boolean {
  return partida.equipeAWO === true || partida.equipeBWO === true;
}

/**
 * Verifica se uma partida tem desistência
 */
export function hasDesistencia(partida: PartidaComWO): boolean {
  return partida.equipeADesistencia === true || partida.equipeBDesistencia === true;
}

